import styled from 'styled-components';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';

export const ShowroomContainer = styled.div`
    display: flex;
    flex: 1 1 0;
    height: 100%;
    overflow: hidden;

    /* Tablet (<= 768px): left nav becomes a fixed overlay drawer; main fills the row */
    @media (max-width: ${BreakPoints.TABLET}) {
        overflow: visible;
    }
`;

export const ShowroomBody = styled.main`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding: 16px;
    overflow: auto;

    /* Slimmer scrollbar (Firefox + WebKit): default classic scrollbars on Windows render
       much wider than macOS overlay scrollbars, making the main content area look
       inconsistent across platforms. */
    scrollbar-width: thin;
    &::-webkit-scrollbar {
        width: 6px;
    }

    @media (max-width: ${BreakPoints.TABLET}) {
        width: 100%;
    }
`;

export const ShowroomCard = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    @media (max-width: ${BreakPoints.TABLET}) {
        min-height: 240px;
        border-radius: 8px;
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        min-height: 200px;
    }
`;

export const SectionPlaceholderRoot = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const SectionPlaceholderAction = styled.div`
    display: flex;
    justify-content: flex-end;

    button {
        width: auto;
        min-height: 50px;
        padding: 12px 20px;
        text-transform: none;
    }

    @media (max-width: ${BreakPoints.PHONE}) {
        button {
            width: 100%;
        }
    }
`;
